var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showError)?_c('div',{staticClass:"reset-password"},[_c('h2',[_vm._v("The link for resetting your password has expired.")]),_c('button',{on:{"click":function($event){return _vm.returnToSignIn()}}},[_vm._v("GO BACK TO LOGIN PAGE")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }